import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { 
  findProductById, 
 
  getProductImage, 
  getProductCsvLookupId 
} from '../../utils/productHelpers';

const GarminEchomapUltra2106sv = () => {
  console.log('🎯 GarminEchomapUltra2106sv component loading');
  
  const product = findProductById("echomap-ultra-2-106sv");
  
  if (!product) {
    console.error('Product not found:', "echomap-ultra-2-106sv");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="echomap-ultra-2-106sv"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
      csvExactMatchOnly={true}
    />
  );
};

export default GarminEchomapUltra2106sv; 